// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2xvmm","colMaxWidth":"Table_colMaxWidth__8yMx2"};